/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import i18n from "i18next";
import { ResponsiveBar } from "@nivo/bar";
import {
  formatNumber,
  isEmptyObj,
  isObj,
  sumValueArrayObject,
  renderLegendNivo,
} from "helpers/utils";
import { fetchSuppression } from "store/actions/suppressionAtions";
import ReportFeedback from "components/ReportFeedback";
import NivoCustomTooltip from "components/NivoCustomTooltip";

function Supressoes() {
  const dispatch = useDispatch();
  const choice = useSelector((state) => state.choice);
  const { suppressions } = useSelector((state) => state.suppression);
  const [data, setData] = useState([]);
  const customColors = ["#134637"];

  useEffect(() => {
    dispatch(fetchSuppression(choice));
  }, [dispatch, choice]);

  useEffect(() => {
    if (isObj(suppressions) && !isEmptyObj(suppressions)) {
      const {
        overlap_ar_ASV_UAS_IRU, // AST X UC / IRU X UC / PCTs x UC
        overlap_ar_ASV_UAS_AST, // AST X TI / IRU X TI / PCTs x TI
        overlap_ar_ASV_UAS_PCT, // AST X QUI / IRU X QUI / PCTs x QUI
        overlap_ar_ASV_UAS_IRU_AST, // AST X AST / IRU X AST / PCTs x AST
        overlap_ar_ASV_UAS_IRU_PCT, // AST X FPND / IRU X FPND / PCTs x FPND
        overlap_ar_ASV_UAS_Outros, // AST X IRU
      } = suppressions;

      setData([
        {
          type: "IRU",
          value: Number(overlap_ar_ASV_UAS_IRU),
        },
        {
          type: "AST",
          value: Number(overlap_ar_ASV_UAS_AST),
        },
        {
          type: "PCT",
          value: Number(overlap_ar_ASV_UAS_PCT),
        },
        {
          type: "IRU x AST",
          value: Number(overlap_ar_ASV_UAS_IRU_AST),
        },
        {
          type: "IRU x PCT",
          value: Number(overlap_ar_ASV_UAS_IRU_PCT),
        },
        {
          type: "Outros",
          value: Number(overlap_ar_ASV_UAS_Outros),
        },
      ]);
    }
  }, [suppressions]);

  // soma os valores
  const totalData = sumValueArrayObject(data, "value");

  return (
    <div className="tcf-map-report--body-territorialcut--ischildren-item">
      <div className="tcf-map-report--body-territorialcut--ischildren-item--title">
        {i18n.t("suppression")}
      </div>
      <div className="tcf-map-report--body-territorialcut--ischildren-item--body">
        {data ? (
          <ResponsiveBar
            data={data}
            keys={["value"]}
            indexBy="type"
            margin={{ top: 10, right: 50, bottom: 150, left: 90 }}
            padding={0.3}
            valueScale={{ type: "linear" }}
            indexScale={{ type: "band", round: true }}
            valueFormat=">-,~"
            colors={customColors}
            borderColor={{
              from: "color",
              modifiers: [["darker", 1.6]],
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: "",
              legendPosition: "middle",
              legendOffset: 32,
              truncateTickAt: 0,
            }}
            axisLeft={{
              tickSize: 0,
              tickPadding: 6,
              tickRotation: 0,
              legend: i18n.t("areaHa"),
              legendPosition: "middle",
              legendOffset: -80,
              truncateTickAt: 0,
            }}
            tooltip={({ indexValue, value }) => {
              const valueFormated = formatNumber(value, 0, ".", ",");
              return (
                <NivoCustomTooltip id={indexValue} value={valueFormated} unit="ha" />
              );
            }}
            enableLabel={false}
            legends={[
              {
                dataFrom: "indexes",
                anchor: "bottom-left",
                direction: "column",
                justify: false,
                translateX: -90,
                translateY: 170,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: "left-to-right",
                itemOpacity: 0.85,
                symbolSize: 0,
                labelTextColor: (d) => console.log(d),
                data: data.map((d) =>
                  renderLegendNivo({
                    type: d.type,
                    value: d.value,
                    total: totalData,
                  })
                ),
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]}
          />
        ) : (
          <ReportFeedback />
        )}
      </div>
    </div>
  );
}

export default Supressoes;
